// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3w3Q4","errorLogs":"EditorFooter_errorLogs__w0IVU"};